import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from '../services/generic.service';
import { CidEnvService } from '../services/cid-env.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private cid_service: CidEnvService, private generic: GenericService, private toastr: ToastrService, private router: Router) { }

  email = '';
  otp = '';
  password = '';
  cid: any
  phoneNumber: any = ""

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'))

    window.scrollTo(0, 0)
    this.phoneNumber = ""
  }

  forgotPassword() {
    let body: any = {
      "cid": this.cid,
      "phone": this.phoneNumber,
    }

    this.generic.forgotPassword(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message)
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  login() {
    let body = {
      emailOrPhone: this.email,
      otp: "",
      password: this.password,
      userType: "admin"
    }
    console.log(body)
    this.generic.adminLogin(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message)
        sessionStorage.setItem('userCreds', JSON.stringify(response.response))
        sessionStorage.setItem('token', response.response.token)
        sessionStorage.setItem('userEmail', response.response.userEmail)
        sessionStorage.setItem('userMobileNo', response.response.userMobileNo)
        sessionStorage.setItem('userName', response.response.userName)
        sessionStorage.setItem('userType', response.response.userType)
        sessionStorage.setItem('imageURL', response.response.imageURL)
        sessionStorage.setItem('userId', response.response.userId)
        // window.location.href = "/admin"
        this.router.navigateByUrl('/admin')

      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

}
